// extracted by mini-css-extract-plugin
module.exports = {"iconsWrapper":"CalendarEvent_iconsWrapper__oev9A","gfeWrapper":"CalendarEvent_gfeWrapper__3j1Nd"};